import { Component } from '@mycolorway/tao';
import { MDCMenuSurface, Corner } from '@material/menu-surface';
import $ from 'jquery';
import Sortable from 'sortablejs';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-table-view-column-setting', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    sortUrl: String,
  },

  ready() {
    this.menuSurfaceRoot = this.querySelector('.mdc-menu-surface');
    this.triggerLink = this.querySelector('.link-trigger-setting');
    this.sortableContainer = this.querySelector('.sortable-container');

    this.mdcMenuSurface = new MDCMenuSurface(this.menuSurfaceRoot);
    this.mdcMenuSurface.setAnchorCorner(Corner.BOTTOM_LEFT);
    this.mdcMenuSurface.setMenuSurfaceAnchorElement(this.triggerLink);
    this.openMenuSurface();

    this.initSortable();
    this.addEventListeners();
  },

  disconnected() {
    this.stopListening();
    if (this.sortable) this.sortable.destroy();
  },

  initSortable() {
    this.sortable = new Sortable(this.sortableContainer, {
      animation: 0,
      draggable: '.mdc-list-item[sortable]',
      handle: '.sortable-handle',
      onEnd: this.handleSortableEnd.bind(this),
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
    });
  },

  addEventListeners() {
    this.listenTo(this.triggerLink, 'click', this.openMenuSurface.bind(this));

    this.listenTo(this.sortableContainer, {
      click: this.handleListItemClick.bind(this),
      'tr-checkbox-field:change': (event) => {
        const checkbox = event.target;
        this.updateColumn({
          todoFieldSequenceId: checkbox.getValue(),
          fieldKey: checkbox.dataset.fieldKey,
          enabled: checkbox.checked,
        });
      },
    });
  },

  openMenuSurface() {
    if (!this.mdcMenuSurface.open) this.mdcMenuSurface.open = true;
  },

  handleListItemClick(event) {
    if (closest(event.target, 'tr-checkbox-field .mdc-form-field')) return;
    if (closest(event.target, '.sortable-handle, .actions')) return;

    const item = closest(event.target, '.mdc-list-item');
    if (item && !item.classList.contains('disabled')) {
      const checkbox = item.querySelector('tr-checkbox-field');
      checkbox.checked = !checkbox.checked;

      this.updateColumn({
        todoFieldSequenceId: checkbox.getValue(),
        fieldKey: checkbox.dataset.fieldKey,
        enabled: checkbox.checked,
      });
    }
  },

  handleSortableEnd(event) {
    const { item, oldIndex, newIndex } = event;
    if (oldIndex === newIndex) return;

    $.ajax({
      url: this.sortUrl,
      data: {
        projects_table_view_column_sort: {
          todo_field_sequence_id: item.querySelector('tr-checkbox-field').getValue(),
          position: newIndex,
        },
      },
      method: 'post',
      dataType: 'script',
    });
  },

  updateColumn({ todoFieldSequenceId, fieldKey, enabled }) {
    if (fieldKey === 'start_date' && enabled) {
      this.enableStartDateColumn(todoFieldSequenceId);
    } else if (fieldKey === 'due_date' && !enabled) {
      this.disableDueDateColumn(todoFieldSequenceId);
    } else {
      $.ajax({
        url: this.url,
        data: {
          projects_table_view_column: {
            todo_field_sequence_id: todoFieldSequenceId,
            enabled,
          },
        },
        method: 'post',
        dataType: 'script',
      });
    }
  },

  enableStartDateColumn(startDateFieldSequenceId) {
    const dueDateCheckbox = this.querySelector('tr-checkbox-field[data-field-key="due_date"]');
    if (!dueDateCheckbox.checked) dueDateCheckbox.checked = true;

    this.updateColumns([
      { todo_field_sequence_id: startDateFieldSequenceId, enabled: true },
      { todo_field_sequence_id: dueDateCheckbox.getValue(), enabled: true },
    ]);
  },

  disableDueDateColumn(dueDateFieldSequenceId) {
    const startDateCheckbox = this.querySelector('tr-checkbox-field[data-field-key="start_date"]');
    if (startDateCheckbox.checked) startDateCheckbox.checked = false;

    this.updateColumns([
      { todo_field_sequence_id: startDateCheckbox.getValue(), enabled: false },
      { todo_field_sequence_id: dueDateFieldSequenceId, enabled: false },
    ]);
  },

  updateColumns(fields) {
    $.ajax({
      url: this.url,
      data: {
        projects_table_view_column: { fields },
      },
      method: 'post',
      dataType: 'script',
    });
  },
});
